import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { NoveltyCfgService } from './novelty-cfg.service';
import { NoveltyResponseModel, NoveltyModel, NoveltyUserModel } from '../models/novelty.model';

@Injectable({
  providedIn: 'root'
})
export class NoveltyService {

  constructor(private noveltyCfgService: NoveltyCfgService, private httpClient: HttpClient) { }

  /**
   * Consulta las novedades
   * @returns Modelo de respuesta
   */
  getAll(): Observable<NoveltyResponseModel> {
    const novelty = this.httpClient.get<NoveltyResponseModel>(this.noveltyCfgService.getCfg().endpointget)
      .pipe(catchError(this.handleError));

    return novelty;
  }

  /**
   * Registra una novedad
   * @param noveltyModel Datos de la novedad
   * @returns Modelo de respuesta
   */
  create(noveltyModel: NoveltyModel): Observable<NoveltyResponseModel> {
    const novelty = this.httpClient.post<NoveltyResponseModel>(this.noveltyCfgService.getCfg().endpointpost, noveltyModel)
      .pipe(catchError(this.handleError));

    return novelty;
  }

  /**
   * Modifica una novedad
   * @param noveltyModel Datos de la novedad
   * @param noveltyId Identificador de la novedad
   * @returns Modelo de respuesta
   */
  public update(noveltyModel: NoveltyModel, noveltyId: number): Observable<NoveltyResponseModel> {
    const novelty = this.httpClient.put<NoveltyResponseModel>(`${this.noveltyCfgService.getCfg().endpointpost}/${noveltyId}`, noveltyModel)
      .pipe(catchError(this.handleError));

    return novelty;
  }

  /**
   * Elimina una novedad
   * @param noveltyId Identificador de la novedad
   * @returns Modelo de respuesta
   */
  delete(noveltyId: number): Observable<NoveltyResponseModel> {
    const novelty = this.httpClient.delete<NoveltyResponseModel>(`${this.noveltyCfgService.getCfg().endpointpost}/${noveltyId}`)
      .pipe(catchError(this.handleError));

    return novelty;
  }

  /**
   * Obtiene el listado de histórico de novedades por companía
   * @param companyIds Identificadores de companía
   * @returns
   */
  getHistorical(companyIds: string[]): Observable<NoveltyResponseModel> {
    const novelty = this.httpClient.get<NoveltyResponseModel>(`${this.noveltyCfgService.getCfg().endpointget}/historic?companyId=${companyIds}`)
      .pipe(catchError(this.handleError));

    return novelty;
  }

  /**
   * Obtiene la url del fichero cargado a S3 para una novedad
   * @param noveltyId Identificador de la novedad
   * @returns Modelo de respuesta
   */
  getUrlAttachment(noveltyId: number): Observable<NoveltyResponseModel> {
    const novelty = this.httpClient.get<NoveltyResponseModel>(`${this.noveltyCfgService.getCfg().endpointpost}/download/${noveltyId}`)
      .pipe(catchError(this.handleError));

    return novelty;
  }

  /**
   * Consulta las novedades por compañías
   * @param companyIds Identificadores de compañía
   * @returns Modelo de respuesta
   */
  getByCompanies(companyIds: string[]): Observable<NoveltyResponseModel> {
    const novelty = this.httpClient.get<NoveltyResponseModel>(`${this.noveltyCfgService.getCfg().endpointget}/user?companyId=${companyIds}`)
      .pipe(catchError(this.handleError));
    return novelty;
  }

  /**
   * Guarda las novedades visualizadas por un usuario
   * @param noveltyUser Identificadores de las novedades visualizadas
   * @returns Modelo de respuesta
   */
  saveViewUser(noveltyUser: NoveltyUserModel): Observable<NoveltyResponseModel> {
    const novelty = this.httpClient.post<NoveltyResponseModel>(`${this.noveltyCfgService.getCfg().endpointpost}/user`, noveltyUser)
      .pipe(catchError(this.handleError));
    return novelty;
  }

  private handleError(error): Promise<any> {
    return Promise.reject(error);
  }
}
